import { Fragment } from 'react';
import { useIsMobile } from '../../misc/mobile';
import './PageHeader.scss';

const PageHeader = (props: {
  text: string;
}) => {
  const isMobile = useIsMobile();

  return (
    <Fragment>
      <div className="app-page-header acrylic-translucent inverted">
        { isMobile ? <h2>{ props.text }</h2> : <h1>{ props.text }</h1> }
      </div>
      <div style={ { height: 120 } }></div>
    </Fragment>
  );
};

export default PageHeader;
